export default __webpack_public_path__ + "static/media/E11.84412157.jpeg";